// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"6b97ba59","213":"65c43823","453":"446048c5","455":"a797c26a"}[chunkId] + ".chunk.js";
};